/** TODO temporary. will be refactored */

import {
    InputType,
    ParameterType,
    ParameterTypeConfig,
    StatusType,
    UserSearchCriteria,
} from './search-user.model';

export interface ParameterFormValue {
    parameterType: ParameterType;
    value?: any;
    status?: StatusType;
}

export interface CriteriaFormValue {
    statusType: StatusType;
    parameters: ParameterFormValue[];
}

export function userSearchCriteriaFromCriteriaFormValueTransformer(
    model: CriteriaFormValue,
): UserSearchCriteria {
    return model.parameters.reduce<UserSearchCriteria>(
        (output, current) => {
            const config = ParameterTypeConfig[current.parameterType];
            (output[config.parameterType] as any) =
                current.value != null
                    ? config.inputType === InputType.DROPDOWN
                        ? current.value
                        : current.value.trim()
                    : null;
            if (config.hasStatus) {
                let val = Array.isArray(current.status)
                    ? current.status[0]
                    : current.status;
                if (model.statusType === StatusType.INACTIVE) {
                    val = StatusType.INACTIVE;
                }
                // TODO revise if to do this. it wasn't being done before
                /* if (model.statusType !== StatusType.INACTIVE && val === StatusType.INACTIVE) {
                val = model.statusType;
            } */
                output[`${config.parameterType.split('Id')[0]}Status`] = val;
            }
            return output;
        },
        {
            activeStatus: model.statusType,
        },
    );
}
